var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ direction: _vm.$vs.rtl ? 'rtl' : 'ltr' })},[(!_vm.params.data.active)?_c('i',{staticClass:"fas fa-circle",staticStyle:{"color":"red"}}):_c('i',{staticClass:"fas fa-circle",staticStyle:{"color":"green"}})])}
var staticRenderFns = []

export { render, staticRenderFns }